import { Box, Typography, useTheme } from "@material-ui/core";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import { CaseIdContainerSectionController } from "./case-id-container-section-controller";
import { GetPreviousInterventionPatients } from "./types/GetPreviousInterventionPatients";

type FormValuesSetType = {
	patientId: string;
};

type InitialResponseType = GetPreviousInterventionPatients;

type SchemaType = { [K in keyof FormValuesSetType]: Yup.AnySchema };

function DuplicateFormBanner() {
	const { t } = useTranslation();
	const { palette } = useTheme();
	const { errors } = useFormikContext<{ isPatientUnique: boolean }>();

	if (!errors.isPatientUnique) {
		return null;
	}

	return (
		<Box p={1} pl={2} marginTop={-3} bgcolor={palette.background.default} width="110%" marginLeft={-5}>
			<Typography variant="subtitle2">{t("patient-is-not-unique")}</Typography>
		</Box>
	);
}

export class PrimaryInterventionDateRelatedDefaultSectionController extends CaseIdContainerSectionController {
	createValidationRule(
		sectionSchema: Yup.ObjectSchema<SchemaType>,
		initialValues: InitialResponseType,
		translate: (key: string) => string
	): Yup.ObjectSchema<any> {
		return sectionSchema.test("patient-must-be-unique", function (values: FormValuesSetType) {
			const isDuplicate = initialValues.previousInterventionPatients?.some(
				(p) => p.insuranceId?.toLowerCase() === values.patientId.trim().toLocaleLowerCase()
			);
			return !isDuplicate || this.createError({ path: "isPatientUnique", message: translate("cr-is-not-unique") });
		});
	}

	renderBeforeContent(): React.ReactElement {
		return <DuplicateFormBanner />;
	}
}
